import React, { FC, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { DocumentBasylic, ErrorType, TrustfullResponse } from "shared/types/types";
import { UserContext } from "features/account";
import { useVerificationAccess } from "features/credits";
import IDIcon from "assets/img/CardVerification2.png";
import { ReactComponent as IconPlay } from "assets/img/icons/icon_Play.svg";
import { ReactComponent as IconUpload } from "assets/img/icons/icon_Upload.svg";
import AddDocumentForm from "components/AddDocumentForm";
import Alert from "shared/ui/Alert";
import BuyCreditsCard from "components/BuyCreditsCard";
import DocumentIllustration from "components/DocumentIllustration";
import ErrorScan from "components/ErrorScan";
import Loader from "shared/ui/Loader";
import VerifyResult from "features/analysis/components/VerifyResult/VerifyResult";
import PageHeader from "components/PageHeader";
import VerifyOverview from "./VerifyOverview";
import VerifyOverviewDarkWeb from "features/darkweb/pages/VerifyOverviewDarkWeb";
import Modal from "shared/ui/Modal";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { ReactComponent as IconFaq } from "assets/img/icons/icon_Faq.svg";
import { ReactComponent as IconDarkWeb } from "assets/img/icons/icon_Thief.svg";
import SponsorShipModal from "components/SponsorShipModal";
import { getShareIdTokenAndApplicantId } from "features/share-id";
import CheckAnotherOne from "features/analysis/components/CheckAnotherOne";
import DashboardTrustful from "features/analysis/components/DashboardTrustful";

const iconProps = {
    fill: "#272f91",
    width: "20px",
};

interface VerifyProps {
    isDarkWeb?: boolean;
}

const Verify: FC<VerifyProps> = ({ isDarkWeb }) => {
    const location = useLocation();
    const [showSponsorModal, setShowSponsorModal] = useState<boolean>(false);

    const [isByVideo, setIsByVideo] = useState<boolean>(false);
    {
        /* TODO: A commenter pour faire marcher Presentation Video*/
    }
    // const [showModal, setShowModal] = useState<boolean>(true);
    {
        /* TODO: A decomenter pour faire marcher Presentation Video*/
    }
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selectedNeverShowAgain, setSelectedNeverShowAgain] = useState(() => {
        /*TODO: A decomenter pour faire marcher Presentation Video*/

        if (!!+(process.env.REACT_APP_FOR_PARTNER_ONLY || 0)) {
            return true;
        } else {
            return localStorage.getItem("VerifyOverview") === "true";
        }
        // return true;
    });
    const [showOverview, setShowOverview] = useState<boolean>(() => {
        // TODO : A décomenter pour faire marcher Video Prsentation
        // return localStorage.getItem("VerifyOverview") === "false";
        if (!!+(process.env.REACT_APP_FOR_PARTNER_ONLY || 0)) {
            return true;
        } else {
            return true;
        }
        // return true
    });
    const [showOverviewDarkWeb, setShowOverviewDarkWeb] = useState<boolean>(() => {
        // TODO : A décomenter pour faire marcher Video Prsentation
        return localStorage.getItem("VerifyOverviewDarkWeb") === "false";
        // return false
    });
    const { user, userType, getMe } = useContext(UserContext);
    const [credits, setCredits] = useState(user?.credits ?? 1);
    // Accès = solde OU vérifications gratuites du mois (règle unique, features/credits).
    // On conserve l'état local `credits` : il est rafraîchi après un achat.
    const { canUse } = useVerificationAccess();
    const canVerify = credits > 0 || canUse;

    useEffect(() => {
        getMe();
    }, [location.pathname, user?.email]);

    const [type, setType] = useState<string>("");
    const [isScanning, setIsScanning] = useState<boolean>(false);
    const [isScanningLoadingText, setIsScanningLoadingText] = useState<string>("Analyse en cours");
    const [isScanned, setIsScanned] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorType, setErrorType] = useState<ErrorType>({ status: 0, message: "" });
    const [verifyReportURL, setVerifyReportURL] = useState<string>("");
    const [document, setDocument] = useState<DocumentBasylic>();
    const [showResult, setShowResult] = useState<boolean>(false);
    const [applicant_id, setApplicant_id] = useState<string>("");
    const [accessToken, setAccessToken] = useState<string>("");
    const [data, setData] = useState<any>(null);
    const [checkAnotherOne, setCheckAnotherOne] = useState<boolean>(false);
    const [anotherOneChecked, setAnotherOneChecked] = useState<boolean>(false);
    const [trustfullData, setTrustfullData] = useState<TrustfullResponse | undefined>(undefined);
    const [selectedCheckbox, setSelectedCheckbox] = useState(selectedNeverShowAgain);

    useEffect(() => {
        if (!isDarkWeb && localStorage.getItem("VerifyOverview") === "false") {
            setShowOverview(true);
        }
    }, [isDarkWeb]);

    const getTokenFromShareId = async () => {
        // SHARE ID TOKEN
        const token = await getShareIdTokenAndApplicantId(userType ?? "");
        if (token) {
            setAccessToken(token.token);
            setApplicant_id(token.applicant_id);
            return token.token;
        }
        return null;
    };

    const refreshPage = () => {
        /* setIsScanned(false);
        setShowResult(false)    ;
        setErrorType({ status: 0, message: "" });
        */
        window.location.href = window.location.href; // Cela permet de rafraichir la page
    };

    const handleStartVerification = async (video: boolean) => {
        if (video) {
            await getTokenFromShareId();
        }
        // setSelectedNeverShowAgain(false);
        setShowModal(false);
        setShowOverview(false);
        setIsByVideo(video);
    };

    const backToChoice = () => {
        setShowOverview(true);
        setCheckAnotherOne(false);
        setSelectedCheckbox(true);
        setIsScanned(false);
    };

    return (
        <>
            <PageHeader
              title={isDarkWeb ? "Dark Web" : "ID Verify"}
              description={"Vérifier ou contrôler un document"}
              notification={user?.type === 'individual'}
              protectAlert={user?.type === 'individual'}
            />


            {((showOverview && !isDarkWeb) || (showOverviewDarkWeb && isDarkWeb)) && canVerify ? (
                isDarkWeb ? (
                    <VerifyOverviewDarkWeb
                        showOverview={showOverviewDarkWeb}
                        setShowOverview={setShowOverviewDarkWeb}
                        setShowModal={setShowModal}
                    />
                ) : (
                    <>
                        <VerifyOverview
                            showOverview={showOverview}
                            setShowOverview={setShowOverview}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            selectedNeverShowAgain={selectedNeverShowAgain}
                            setSelectedNeverShowAgain={setSelectedNeverShowAgain}
                            handleStartVerification={handleStartVerification}
                            setCheckAnotherOne={setCheckAnotherOne}
                            setSelectedCheckbox={setSelectedCheckbox}
                            selectedCheckbox={selectedCheckbox}
                        />
                    </>
                )
            ) : (
                <div className="VerifyPage content__body h-100">
                    <div className="VerifyPage__row row h-100">
                        <div className="VerifyPage__content col-sm-6">
                            {!canVerify ? (
                                <>
                                    <Alert type="error">
                                        Vous n'avez plus de vérification disponible. Veuillez en acheter.
                                    </Alert>
                                    <BuyCreditsCard
                                        showSponsorModal={showSponsorModal}
                                        setShowSponsorModal={setShowSponsorModal}
                                    />
                                    {showSponsorModal && (
                                        <SponsorShipModal
                                            isOpen={showSponsorModal}
                                            onClose={() => setShowSponsorModal(false)}
                                        />
                                    )}
                                </>
                            ) : !isScanning && !isScanned && errorType?.status !== 400 && !showResult && !checkAnotherOne ? (
                                <>
                                    <AddDocumentForm
                                        onChangeType={setType}
                                        type={type}
                                        setIsScanning={setIsScanning}
                                        setIsScanningLoadingText={setIsScanningLoadingText}
                                        setIsScanned={setIsScanned}
                                        setErrorMessage={setErrorMessage}
                                        setDocument={setDocument}
                                        isVerification
                                        errorType={errorType}
                                        setErrorType={setErrorType}
                                        setVerifyReportURL={setVerifyReportURL}
                                        isDarkWeb={isDarkWeb}
                                        isByVideo={isByVideo}
                                        setApplicant_id={setApplicant_id}
                                        applicant_id={applicant_id}
                                        accessToken={accessToken}
                                        setAccessToken={setAccessToken}
                                        setData={setData}
                                        backToChoice={backToChoice}
                                    />
                                </>
                            ) : errorType?.status !== 400 && !checkAnotherOne && !anotherOneChecked ? (
                                <VerifyResult
                                    isScanning={isScanning}
                                    documentVerified={document}
                                    refresh={refreshPage}
                                    verifyReportURL={verifyReportURL}
                                    errorMessage={errorMessage}
                                    isDarkWeb={isDarkWeb}
                                    setApplicant_id={setApplicant_id}
                                    applicant_id={applicant_id}
                                    data={data}
                                />
                            ) : checkAnotherOne ? (
                                <CheckAnotherOne
                                    isScanning={isScanning}
                                    setIsScanning={setIsScanning}
                                    setCheckAnotherOne={setCheckAnotherOne}
                                    setAnotherOneChecked={setAnotherOneChecked}
                                    setIsScanned={setIsScanned}
                                    setTrustfullData={setTrustfullData}
                                    backToChoice={backToChoice}
                                />
                            ) : anotherOneChecked && isScanned ? (
                                <DashboardTrustful
                                    trustfullData={trustfullData}
                                    backToChoice={backToChoice}
                                />
                            ) : (
                                <ErrorScan
                                    error={errorType?.message}
                                    verifyReportURL={verifyReportURL}
                                    resetState={refreshPage}
                                />
                            )}
                        </div>
                        {!anotherOneChecked && (
                            <div className="VerifyPage__illu col-sm-6 center">
                                <h1 className={`text-center mb-4 ${checkAnotherOne? 'text-md' : 'VerifyPage__title'}`}>
                                    {checkAnotherOne
                                        ? "Contrôlez l’identité à partir des informations"
                                        : isDarkWeb
                                        ? "Votre document d'identité est-il sur le dark web ?"
                                        : "Vérifiez l'authenticité d'un document"}
                                </h1>
                                {!(checkAnotherOne && isScanning) && <DocumentIllustration type={type} />}
                                {isScanning && <Loader text={isScanningLoadingText} />}
                            </div>
                        )}
                    </div>
                    {/* TODO: A decomenter pour faire marcher Presentation Video*/}
                    {!isScanned && canVerify && (
                        <div className="d-flex justify-content-center align-items-center gap-05">
                            <u
                                className="pointer font-SM"
                                onClick={() => {
                                    if (isDarkWeb) {
                                        setShowOverviewDarkWeb(true);
                                    } else {
                                        setShowOverview(true);
                                        setCheckAnotherOne(false);
                                        setSelectedCheckbox(false);
                                    }
                                }}>
                                Découvrez-vous le fonctionnement {isDarkWeb ? "notre Dark Web" : "d'ID Verify"}
                            </u>
                            <IconFaq {...iconProps} />
                        </div>
                    )}
                </div>
            )}
            {/* TODO: A Commenter pour faire marcher Presentation Video*/}
            {showModal && !isDarkWeb && canVerify && !+(process.env.REACT_APP_FOR_PARTNER_ONLY || 0) && (
                <Modal
                    onClose={() => setShowModal(false)}
                    isOpen={showModal}
                    title="Vérifier un document"
                    infoModal
                    type="info">
                    <div className="w-100">
                        <p>J’effectue la vérification par :</p>
                        <div className="d-flex gap-05 flex-wrap">
                            <Button
                                label="Vidéo"
                                style={Button_Style.OUTLINED}
                                onClick={() => handleStartVerification(true)}
                                icon={<IconPlay />}
                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                            />
                            <Button
                                label="Photo"
                                style={Button_Style.OUTLINED}
                                onClick={() => handleStartVerification(false)}
                                icon={<IconUpload />}
                                type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY}
                            />
                        </div>
                    </div>
                </Modal>
            )}
            {/* TODO: A decomenter pour faire marcher Presentation Video*/}
            {/*{((showModal && !isDarkWeb) || (selectedNeverShowAgain && !isDarkWeb)) && credits > 0 && (
                <Modal onClose={() => selectedNeverShowAgain && setShowModal(false)} isOpen={showModal} title="Vérifier un document" infoModal type="info">
                    <div className="w-100">
                        <p>J’effectue la vérification par :</p>
                        <div className="d-flex gap-05 flex-wrap">
                            <Button label="Vidéo" style={Button_Style.OUTLINED} onClick={() => handleStartVerification(true)} icon={<IconPlay />} type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY} />
                            <Button label="Photo" style={Button_Style.OUTLINED} onClick={() => handleStartVerification(false)} icon={<IconUpload />} type={userType === "partner" ? Button_Type.SECONDARY : Button_Type.PRIMARY} />
                        </div>
                    </div>
                </Modal>
            )}*/}
        </>
    );
};

export default Verify;
